(function() {
  function getStepsTarget() {
    var anchor = document.getElementById('steps');
    if (!anchor) return null;
    // Find the Shopify section wrapper, then get the next section
    var section = anchor.closest('.shopify-section');
    if (section && section.nextElementSibling) {
      return section.nextElementSibling;
    }
    return anchor;
  }

  function scrollToSteps() {
    var target = getStepsTarget();
    if (!target) return;
    var rect = target.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var targetTop = rect.top + scrollTop - 120;
    window.scrollTo(0, targetTop);
  }

  function attachScrollButtons() {
    var allLinks = document.querySelectorAll('a');
    var found = 0;
    allLinks.forEach(function(link) {
      var btnText = link.querySelector('.btn-text');
      if (!btnText) return;
      var raw = '';
      for (var i = 0; i < btnText.childNodes.length; i++) {
        if (btnText.childNodes[i].nodeType === 3) {
          raw += btnText.childNodes[i].textContent;
        }
      }
      raw = raw.trim();
      if (raw === 'Shop Now') {
        found++;
        link.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          scrollToSteps();
        });
      }
    });
  }

  if (document.readyState === 'complete') {
    attachScrollButtons();
  } else {
    window.addEventListener('load', attachScrollButtons);
  }

  if (window.location.hash === '#steps') {
    window.addEventListener('load', function() {
      setTimeout(scrollToSteps, 500);
    });
  }
})();
